import type { ModalData } from '..';

export interface MtFreeApplicationsModalData {
  modal: ModalData;
}

export interface MtFreeApplicationsModalProps extends MtFreeApplicationsModalData {}
